/* Affekt · Online Terapi v2 eki
   ak-terapi.js'ten ÖNCE yüklenir.
   1) Seanslarım: iptal en az 48 saat, gün/saat değişikliği talebi en az 24 saat önce.
   2) Eşleştirme: "Çocuğum için" seçeneği, bütçe sorusu ve uzman ücreti kaldırıldı.
   3) Randevu: paket seçeneklerinde ücret yok; ücret yalnızca son adımdaki özette görünür. */
(function () {
  'use strict';
  var HOUR = 36e5, MOVE_H = 24, CANCEL_H = 48;

  // ---------- 1) Süre kuralları (Seanslarım verisi) ----------
  var of = window.fetch;
  if (of && !of.__akt2) {
    var nf = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (!/\/apps\/terapi\/api\/me(\?|$)/.test(url)) return p;
      return p.then(function (r) {
        if (!r.ok) return r;
        return r.clone().json().then(function (d) {
          var t = Date.now();
          (d.bookings || []).forEach(function (b) {
            if (b.start - t < MOVE_H * HOUR) b.can_move = false;
            if (b.start - t < CANCEL_H * HOUR) b.can_cancel = false;
          });
          d.rules = d.rules || {};
          d.rules.reschedule_h = MOVE_H;
          d.rules.cancel_h = CANCEL_H;
          return new Response(JSON.stringify(d), { status: r.status, statusText: r.statusText, headers: { 'Content-Type': 'application/json' } });
        }).catch(function () { return r; });
      });
    };
    nf.__akt2 = true;
    window.fetch = nf;
  }

  // ---------- 2) Eşleştirme ----------
  function fixMatch(box) {
    Array.prototype.forEach.call(box.querySelectorAll('.akt-opt b'), function (b) {
      if (b.textContent === 'Çocuğum veya ergenim için') b.textContent = 'Çocuğum için';
    });
    Array.prototype.forEach.call(box.querySelectorAll('h3.akt-h3'), function (h) {
      if (/zaman ve bütçe/.test(h.textContent)) h.innerHTML = 'Ne zaman <span class="ak-serif">başlamak istersiniz?</span>';
    });
    Array.prototype.forEach.call(box.querySelectorAll('p.akt-lbl'), function (p) {
      if (/bütçe/i.test(p.textContent)) {
        var w = p.nextElementSibling;
        if (w && w.classList.contains('akt-wrap')) w.parentNode.removeChild(w);
        p.parentNode.removeChild(p);
      } else if (/Ne zaman başlamak/.test(p.textContent)) {
        p.parentNode.removeChild(p);
      }
    });
    Array.prototype.forEach.call(box.querySelectorAll('.akt-res b.akt-push'), function (b) { b.parentNode.removeChild(b); });
  }

  // ---------- 3) Randevu paket seçenekleri ----------
  function fixBook(view) {
    Array.prototype.forEach.call(view.querySelectorAll('button.akt-opt--row'), function (btn) {
      var price = null, sub = null;
      for (var i = 0; i < btn.children.length; i++) if (btn.children[i].tagName === 'B') price = btn.children[i];
      var first = btn.children[0];
      if (first && first.tagName === 'SPAN') sub = first.querySelector('span');
      if (!price || price.classList.contains('akt-disc')) return;
      var v = btn.getAttribute('data-v');
      var m = sub && sub.textContent.match(/%\d+ indirim/);
      if (m) {
        price.textContent = m[0];
        price.className = 'akt-disc';
        sub.textContent = (v === 'pack8' ? '8' : '4') + ' seans · 50 dk';
      } else {
        btn.removeChild(price);
      }
    });
  }

  function watch(el, fn) {
    if (!el || !window.MutationObserver) return;
    fn(el);
    new MutationObserver(function () { fn(el); }).observe(el, { childList: true, subtree: true });
  }
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-akt-match-body]'), function (el) { watch(el, fixMatch); });
    Array.prototype.forEach.call(document.querySelectorAll('[data-akt-book] [data-akt-view]'), function (el) { watch(el, fixBook); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
